'use client';

import React from 'react';
import { faUserShield } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { Chip, Tooltip } from 'src/components/PulseUI';

const LABEL = 'MedScout internal — support only';
const DESCRIPTION =
  'Visible to MedScout staff only. This view includes internal fields and actions that customers never see.';

interface InternalViewBadgeProps {
  className?: string;
}

/**
 * @description Marks a settings surface as MedScout-internal so support staff
 *              can tell at a glance that what they are looking at is not the
 *              customer's view. Render it behind
 *              `userManagementCapabilities.isStaff` — the badge does not gate
 *              itself.
 * @returns React.ReactElement
 */
const InternalViewBadge: React.FC<InternalViewBadgeProps> = ({
  className = '',
}) => (
  <Tooltip content={DESCRIPTION} delay={200}>
    <Chip
      size="sm"
      variant="soft"
      color="warning"
      className={className}
      startDecorator={<Icon icon={faUserShield} className="h-3 w-3" />}
      data-testid="internal-view-badge"
      aria-label={`${LABEL}. ${DESCRIPTION}`}
    >
      {LABEL}
    </Chip>
  </Tooltip>
);

export default InternalViewBadge;
